import { ColCateg, Sorting } from '@features/social-analysis/models/ITable';
import { COMPONENTS_ENUM } from './page.config';
import { IgMedia, IgUser } from '@core/models/ApiFields/ig-entities';
import { getDefaultColsObj } from '@features/social-analysis/utils/table-utils';

export const tagsMentionsFields = [
    IgMedia.getPrefixed('caption'),
    IgMedia.getPrefixed('captionSentiment'),
    IgMedia.getPrefixed('comments'),
    IgMedia.getPrefixed('commentsNegativity'),
    IgMedia.getPrefixed('commentsPositivity'),
    IgMedia.getPrefixed('contentType'),
    IgMedia.getPrefixed('engagementRate'),
    IgMedia.getPrefixed('resources'),
    IgMedia.getPrefixed('likes'),
    IgMedia.getPrefixed('mediaId'),
    IgMedia.getPrefixed('mediaType'),
    IgMedia.getPrefixed('negativeComments'),
    IgMedia.getPrefixed('permalink'),
    IgMedia.getPrefixed('positiveComments'),
    IgMedia.getPrefixed('publishDate'),
    IgMedia.getPrefixed('username'),
    IgUser.getPrefixed('followers'),
    IgUser.getPrefixed('image'),
    IgUser.getPrefixed('influencer'),
    IgUser.getPrefixed('professional'),
    IgUser.getPrefixed('profileLink'),
];

const columns: ColCateg[] = [
    {
        display: 'social',
        values: [
            {
                display: 'Posted on',
                value: IgMedia.getPrefixed('publishDate'),
                defaultCol: true,
                fixWidth: 140,
            },
            {
                display: 'Username',
                value: IgMedia.getPrefixed('username'),
                defaultCol: true,
                fixWidth: 160,
            },
            {
                display: 'Post',
                value: IgMedia.getPrefixed('resources'),
                defaultCol: true,
            },
            {
                display: 'Caption',
                value: IgMedia.getPrefixed('caption'),
                defaultCol: true,
                fixWidth: 180,
            },
            {
                display: 'Media type',
                value: IgMedia.getPrefixed('mediaType'),
                defaultCol: true,
            },
            {
                display: 'Influencer',
                value: IgUser.getPrefixed('influencer'),
                defaultCol: true,
            },
            {
                display: 'Caption sentiment',
                value: IgMedia.getPrefixed('captionSentiment'),
            },
            {
                display: 'Comments sentiment',
                value: IgMedia.getPrefixed('commentsPositivity'),
                defaultCol: true,
            },
            {
                display: 'Num. of Comments',
                value: IgMedia.getPrefixed('comments'),
                defaultCol: true,
            },
            {
                display: 'Engagement rate',
                value: IgMedia.getPrefixed('engagementRate'),
                defaultCol: true,
            },
            {
                display: 'Followers',
                value: IgUser.getPrefixed('followers'),
            },
            {
                display: 'Likes',
                value: IgMedia.getPrefixed('likes'),
                defaultCol: true,
            },
            {
                display: 'Negative comments',
                value: IgMedia.getPrefixed('negativeComments'),
            },
            {
                display: 'Positive comments',
                value: IgMedia.getPrefixed('positiveComments'),
            },
        ],
    },
];

const defaultSort: Sorting[] = [{ prop: IgMedia.getPrefixed('publishDate'), dir: 'desc' }];

export const socTagsMentTableInit = {
    component: COMPONENTS_ENUM.TAGS_MENTIONS,
    columns: columns,
    selectedCols: getDefaultColsObj(columns),
    hiddenSort: defaultSort,
};
